const dev = {
	apiGateway: {
		apiUrl: 'https://localhost:44356/api/v1/',
		realSizeApiUrl: 'http://localhost:92/', 
		geocoderApiUrl: 'http://localhost:5000/'
	},
	appSetting: {
		baseUrl: 'http://localhost:3000/',
	},
	application: {
		privacy: "https://www.kloudship.com/tos.html",
		term: "https://www.kloudship.com/tos.html",
	},
	authMS:{
		apiBaseUrl:"https://localhost:7181/api/",
		authMSAuthorizeUrl: "https://localhost:7181/api/auth?pi={productId}&gt={grantType}&ru={redirectUri}&st={state}&cc={codeChallenge}",
		productId:"646385a4f85e18be686695a3",
		grantType:"PKCE",
		redirectUri:"http://localhost:3000/signin"
	},
	version: "1.2513.0"
};

const qa = {
	apiGateway: {
		apiUrl: 'https://api-qa.kloudship.com:94/api/v1/',
		realSizeApiUrl: 'https://api-qa.kloudship.com:92/',
		geocoderApiUrl: 'https://api-qa.kloudship.com:98/'
	},
	appSetting: {
		baseUrl: 'https://tools-qa.kloudship.com/',
	},
	application: {
		privacy: "https://www.kloudship.com/tos.html",
		term: "https://www.kloudship.com/tos.html",
	},
	authMS:{
		apiBaseUrl:"https://auth-qa.kloudship.com:97/api/",
		authMSAuthorizeUrl: "https://auth-qa.kloudship.com:97/api/auth?pi={productId}&gt={grantType}&ru={redirectUri}&st={state}&cc={codeChallenge}",
		productId:"646385a4f85e18be686695a3",
		grantType:"PKCE",
		redirectUri:"https://tools-qa.kloudship.com/signin"
	},
	version: "1.2513.0"
};

const prod = {
	apiGateway: {
		apiUrl: 'https://api.kloudship.com:94/api/v1/',
		realSizeApiUrl: 'https://api.kloudship.com:92/',
		geocoderApiUrl: 'https://api-qa.kloudship.com:98/'
	},
	appSetting: {
		baseUrl: 'https://tools.kloudship.com/',
	},
	application: {
		privacy: "https://www.kloudship.com/tos.html",
		term: "https://www.kloudship.com/tos.html",
	},
	authMS:{
		apiBaseUrl:"https://auth.kloudship.com:97/api/",
		authMSAuthorizeUrl: "https://auth.kloudship.com:97/api/auth?pi={productId}&gt={grantType}&ru={redirectUri}&st={state}&cc={codeChallenge}",
		productId:"646385a4f85e18be686695a3",
		grantType:"PKCE",
		redirectUri:"https://tools.kloudship.com/signin"
	},
	version: "1.2513.0"
};

const common = {
	feedbackFormImageLimit: 3,
	realSizeFormMinValue: 0.1
};

let config = dev;

switch (process.env.REACT_APP_ENV) {
	case 'qa':
		config = qa;
		break;
	case 'prod':
		config = prod;
		break;
}

export default Object.assign({}, {
	...common,
	...config,
});